"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionEvaluator = void 0;
var ExpressionEvaluator_1 = require("./ExpressionEvaluator");
var ConditionEvaluator = /** @class */ (function () {
    function ConditionEvaluator() {
    }
    ConditionEvaluator.evaluateCondition = function (conditions, conditionId, interaction) {
        var condition = conditions.find(function (x) { return x.id === conditionId; });
        if (condition) {
            return ExpressionEvaluator_1.ExpressionEvaluator.evaluateBoolean(condition.expression, interaction);
        }
        throw Error("Invalid condition: ".concat(conditionId));
    };
    return ConditionEvaluator;
}());
exports.ConditionEvaluator = ConditionEvaluator;
//# sourceMappingURL=ConditionEvaluator.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-services/dist/ConditionEvaluator.js
// module id = 957
// module chunks = 0